export default __webpack_public_path__ + "img/1ab0a45f1be4df7f13b52ec41a60af15.svg";